import { typedBoolean } from '@shared/helpers'
import { PrimaryReasonForIfp } from '@shared/sec-loans'
import { YesNo } from '@ui-common/types'
import { getEditLabel } from '@ui-common/utils'
import { StepSummary, StepSummaryView } from '@ui-components/form/StepSummaryView'
import { useIntl } from 'react-intl'

import { WizardStep } from '../../wizard/wizardMachine'
import { getIfpInfoStepLocalizedEnums } from './ifpInfoStepUtils'
import { IfpBasicInfoFormData } from './types'

export const IfpInfoSummary = ({
  data,
  onEditRequest,
}: {
  data: IfpBasicInfoFormData
  onEditRequest?: (stepType: WizardStep) => void
}) => {
  const intl = useIntl()

  const { yesNoTexts, primaryReasonLabels } = getIfpInfoStepLocalizedEnums(intl.formatMessage)

  const summary: StepSummary = {
    heading: intl.formatMessage({ id: 'ifp-loans-info-step-heading' }),
    data: [
      {
        heading: intl.formatMessage({ id: 'ifp-loans-duration-label' }),
        value: data.durationInMonths,
      },
      {
        heading: intl.formatMessage({ id: 'ifp-loans-starts-immediately-label' }),
        value: yesNoTexts[data.startsImmediately],
        childData:
          data.startsImmediately === YesNo.No
            ? [
                {
                  heading: intl.formatMessage({ id: 'ifp-loans-start-date-label' }),
                  value: data.startDate,
                },
              ]
            : undefined,
      },
      {
        heading: intl.formatMessage({ id: 'ifp-loans-primary-reason-label' }),
        value: primaryReasonLabels[data.primaryReason],
        childData: [
          data.primaryReason === PrimaryReasonForIfp.Other
            ? {
                heading: intl.formatMessage({ id: 'ifp-loans-other-reason-for-ifp-label' }),
                value: data.primaryReasonOther,
              }
            : undefined,
          {
            heading: intl.formatMessage({ id: 'ifp-loans-experiencing-financial-difficulties-label' }),
            value: yesNoTexts[data.hasFinancialDifficulties],
          },
        ].filter(typedBoolean),
      },
    ],
    editItemProperties: onEditRequest && {
      onClick: () => onEditRequest(WizardStep.IfpInfoStep),
      label: getEditLabel(intl),
    },
  }

  return <StepSummaryView {...summary} />
}
